<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    DESPESAS GERAIS -
                    <b-badge variant="warning">{{ acao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="numeroNota">
                                    Número da Nota/Fatura
                                </label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="numeroNota"
                                        placeholder="Digite o número da nota/fatura"
                                        v-model="numeroNota"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label class="required" for="tipoMovimento">
                                    Tipo de movimento
                                </label>
                                <b-form-select
                                    id="tipoMovimento"
                                    :options="opcoes.tiposMovimentos"
                                    v-model="tipoMovimento"
                                    text-field="codNomeTipoMovimento"
                                    value-field="tipoMovimentoId"
                                    :disabled="desabilitaTipoMovimento"
                                ></b-form-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="4">
                            <b-form-group>
                                <label class="required">
                                    Demandante
                                </label>
                                <model-list-select
                                    v-if="opcoes.funcionarios != null"
                                    :list="opcoes.funcionarios"
                                    option-text="nome"
                                    option-value="chapa"
                                    v-model="demandante"
                                    @input="$v.demandante.$touch()"
                                ></model-list-select>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="1">
                            <label> </label>
                            <b-checkbox
                                v-model="alcadaGerencia"
                                @change="limparAutorizante($event)"
                            >
                                Alçada da gerência
                            </b-checkbox>
                        </b-col>
                        <b-col sm="12" md="4" v-if="alcadaGerencia">
                            <b-form-group>
                                <label class="required">
                                    Autorizante
                                </label>
                                <model-list-select
                                    v-if="opcoes.funcionarios != null"
                                    :list="opcoes.funcionarios"
                                    option-text="nome"
                                    option-value="chapa"
                                    v-model="autorizante"
                                    @input="$v.autorizante.$touch()"
                                ></model-list-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="!perfilFornecedor">
                        <b-col sm="12" md="3" v-if="!fornecedorExterno">
                    <b-form-group >
                        <label class="required" >CPF/CNPJ Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                maxlength="18"
                                placeholder="Digite o CPF ou CNPJ do fornecedor"
                                v-model="fornecedorCPFCNPJ"
                                
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarFornecedor()"
                                    title="Clique para pesquisar o fornecedor"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                            <b-form-invalid-feedback>
                                O CPF ou CNPJ do fornecedor é obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3" v-if="fornecedorExterno">
                    <b-form-group >
                        <label class="required" >Código Formecedor</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                maxlength="8"
                                placeholder="Digite o Código do fornecedor"
                                v-model="fornecedorCodCfo"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="pesquisarFornecedor()"
                                    title="Clique para pesquisar o fornecedor"
                                >
                                    <i class="fa fa-search"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md=2>
                    <b-form-group>
                        <label>
                        </label>
                        <b-checkbox
                            v-model="fornecedorExterno"
                        >
                            Fornecedor Estrangeiro
                        </b-checkbox>
                    </b-form-group>
                </b-col>
                        <b-col sm="12" md="5" v-if="fornecedorDto">
                            <b-form-group>
                                <label for="razaoSocial">Razão social</label>
                                <b-input-group>
                                    <b-form-input
                                        type="text"
                                        id="razaoSocial"
                                        v-model="fornecedorDto.nome"
                                        :disabled="true"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="2">
                            <b-form-group
                                :state="$v.dataEmissao.$error ? false : null"
                                invalid-feedback="A data da emissão é obrigatória"
                            >
                                <label class="required" for="dataEmissao">
                                    Data de emissão
                                </label>
                                <date-picker
                                    id="dataEmissao"
                                    v-model="dataEmissao"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    @input.native="$v.dataEmissao.$touch()"
                                    :disabled="despesaCompra"
                                ></date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group
                                :state="$v.dataMovimento.$error ? false : null"
                                invalid-feedback="A data do movimento é obrigatória"
                            >
                                <label class="required" for="dataMovimento">
                                    Data de movimento
                                </label>
                                <date-picker
                                    ref="dp2"
                                    id="dataMovimento"
                                    v-model="dataMovimento"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    @input.native="$v.dataMovimento.$touch()"
                                    :disabled="despesaCompra"
                                ></date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="2">
                            <b-form-group>
                                <label
                                    for="dataVencimento"
                                    v-bind:class="{
                                        required: boleto
                                    }"
                                >
                                    Data de vencimento
                                </label>
                                <date-picker
                                    ref="dp3"
                                    id="dataVencimento"
                                    v-model="dataVencimento"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    :disabled="despesaCompra"
                                ></date-picker>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="1">
                            <label> </label>
                            <b-checkbox v-model="boleto">
                                Boleto
                            </b-checkbox>
                        </b-col>
                        <b-col
                            sm="12"
                            md="4"
                            v-if="dataVencimentoRequerJustificativa"
                        >
                            <b-form-group>
                                <label class="required"
                                    >Justificativa para Data de
                                    Vencimento</label
                                >
                                <b-form-textarea
                                    v-model="justificativaDataVencimento"
                                    :rows="3"
                                    @input="
                                        $v.justificativaDataVencimento.$touch()
                                    "
                                    :state="
                                        $v.justificativaDataVencimento.$error
                                            ? false
                                            : null
                                    "
                                ></b-form-textarea>
                                <b-form-invalid-feedback
                                    >É necessario justificar porque a data de
                                    vencimento tem um prazo menor que 15 dias
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label class="required">Histórico</label>
                                <b-form-textarea
                                    v-model="historico"
                                    :rows="3"
                                    @input="$v.historico.$touch()"
                                    :state="$v.historico.$error ? false : null"
                                    :disabled="despesaCompra"
                                ></b-form-textarea>
                                <b-form-invalid-feedback
                                    >O histórico é obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
            <b-card-footer>
                <slot name="botoes"></slot>
                <div class="float-right">
                    <b-button
                        variant="success"
                        @click.stop="confirmarSalvar()"
                        :disabled="!habilitarSalvar"
                    >
                        <span>
                            <i class="fa fa-check"></i>
                            {{ acao == 'INSERIR' ? 'Salvar' : 'Atualizar' }}
                        </span>
                    </b-button>
                </div>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { ModelListSelect } from 'vue-search-select'

export default {
    props: {
        acao: {
            type: String,
            default: () => ''
        },

        opcoes: {
            type: Object,
            default: () => ({})
        },

        fornecedor: {
            type: Object
        },

        despesa: {
            type: Object
        },

        perfilFornecedor: {
            type: Boolean,
            default: () => false
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            numeroNota: null,
            demandante: null,
            tipoMovimento: null,
            alcadaGerencia: false,
            autorizante: null,
            fornecedorCPFCNPJ: null,
            fornecedorDto: null,
            dataEmissao: null,
            dataMovimento: null,
            dataVencimento: null,
            boleto: false,
            historico: null,
            justificativaDataVencimento: '',
            fornecedorCodCfo: null,
            fornecedorExterno: false,
        }
    },

    methods: {
        limparAutorizante(evento) {
            if (this.acao == 'INSERIR') {
                this.autorizante = null
            }
        },

        pesquisarFornecedor() {
            var referencia = this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ;
            if(!/[a-zA-Z]/.test(referencia) && referencia.length > 0)
            {
                if (this.validaTamanhoCpfCnpj) {
                    this.$emit('pesquisarFornecedor', this.fornecedorExterno ? this.fornecedorCodCfo : this.fornecedorCPFCNPJ.apenasNumeros())
                }
            }
        },

        preencherForm() {
            this.numeroNota = this.despesa.numeroNota
            this.demandante = this.despesa.codDemandante
            this.alcadaGerencia = this.despesa.alcadaGerencia
            this.autorizante = this.despesa.codAutorizante
            this.tipoMovimento = this.despesa.tipoMovimento.tipoMovimentoId
            this.dataEmissao = this.$moment(this.despesa.dataEmissao).format(
                'DD/MM/YYYY'
            )
            this.dataMovimento = this.$moment(
                this.despesa.dataMovimento
            ).format('DD/MM/YYYY')
            this.dataVencimento =
                this.despesa.dataVencimento != null
                    ? this.$moment(this.despesa.dataVencimento).format(
                          'DD/MM/YYYY'
                      )
                    : null
            this.boleto = this.despesa.boleto
            this.historico = this.despesa.historico
            this.justificativaDataVencimento = this.despesa.justificativaDataVencimento

            this.fornecedorDto = {
                cpfCnpj: this.despesa.cpfCnpj,
                nome: this.despesa.nomeFornecedor,
                codCfo: this.despesa.codCfo
            }
            this.fornecedorCPFCNPJ = this.despesa.cpfCnpj
            this.fornecedorCodCfo = this.despesa.codCfo
            this.fornecedorExterno = this.despesa.fornecedorExterno
        },

        confirmarSalvar() {
            let demandanteDto = this.opcoes.funcionarios.find(x => x.chapa == this.demandante) 
            let autorizanteDto = this.opcoes.funcionarios.find(x => x.chapa == this.autorizante) 
            let tipoMovimentoDto = this.opcoes.tiposMovimentos.find(x => x.tipoMovimentoId == this.tipoMovimento)
            this.fornecedorDto.fornecedorExterno = this.fornecedorExterno
            let despesaDto = {
                numeroNota: this.numeroNota,
                fornecedorDto: this.fornecedorDto,
                demandanteDto: demandanteDto,
                alcadaGerencia: this.alcadaGerencia,
                autorizanteDto: autorizanteDto,
                dataEmissao: this.$moment(
                    this.dataEmissao,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dataMovimento: this.$moment(
                    this.dataMovimento,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dataVencimento:
                    this.dataVencimento != null
                        ? this.$moment(
                              this.dataVencimento,
                              'DD/MM/YYYY'
                          ).format('YYYY-MM-DD')
                        : null,
                historico: this.historico,
                boleto: this.boleto,
                tipoMovimentoDto: tipoMovimentoDto,
                justificativaDataVencimento:
                    this.dataVencimentoRequerJustificativa == true
                        ? this.justificativaDataVencimento
                        : null
            }

            this.$swal({
                title: 'Despesa',
                html: `Confirma a ${
                    this.acao == 'INSERIR' ? 'inserção' : 'atualização'
                } da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar(despesaDto)
                }
            })
        },

        formatCPFCNPJ() {
            let onlyNumbers = this.fornecedorCPFCNPJ.replace(/\D/g, "");
            if (onlyNumbers.length <= 11) {
                this.fornecedorCPFCNPJ = this.formatCPF(onlyNumbers);
            } else if (onlyNumbers.length > 11 && onlyNumbers.length < 14) {
                this.fornecedorCPFCNPJ = onlyNumbers;
            } else if (onlyNumbers.length === 14) {
                this.fornecedorCPFCNPJ = this.formatCNPJ(onlyNumbers);
            }
        },
    formatCPF(value) {
        return value
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        },

    formatCNPJ(value) {
        return value
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2");
        },

        salvar(despesaDto) {
            if (this.acao == 'INSERIR') {
                this.$emit('inserir', despesaDto)
            } else {
                despesaDto.despesaId = this.despesa.despesaId
                this.$emit('atualizar', despesaDto)
            }
        }
    },

    created() {
        if (this.acao == 'INSERIR') {
            this.dataEmissao = this.$moment().format('DD/MM/YYYY')
        }
    },

    watch: {
        despesa() {
            if (this.acao == 'ATUALIZAR' && this.despesa != null) {
                this.preencherForm()
            }
        },
        fornecedor() {
            if (this.fornecedor != null) {
                this.fornecedorDto = this.fornecedor
            }                
        },

        fornecedorExterno() {
            this.fornecedorCPFCNPJ = null
            this.fornecedorCodCfo = null
        },

        fornecedorCPFCNPJ() {
            if(this.fornecedorCPFCNPJ != null && this.fornecedorCPFCNPJ.length > 0)
            {
                let onlyNumbers = this.fornecedorCPFCNPJ.replace(/\D/g, "");
                if (onlyNumbers.length <= 11) {
                    this.fornecedorCPFCNPJ = null;
                    this.fornecedorCPFCNPJ = this.formatCPF(onlyNumbers);
                } 
                else if (onlyNumbers.length > 11 && onlyNumbers.length < 14) {
                    this.fornecedorCPFCNPJ = onlyNumbers;
                }
                else if (onlyNumbers.length === 14) {
                    this.fornecedorCPFCNPJ = this.formatCNPJ(onlyNumbers);
                }
            }
        },

        fornecedorCodCfo() {
            if(this.fornecedorCodCfo != null && this.fornecedorCodCfo.length > 0)
            {
                let onlyNumbers = this.fornecedorCodCfo.replace(/\D/g, "");
                this.fornecedorCodCfo = onlyNumbers;
            }
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        validaTamanhoCpfCnpj() {
            if (this.fornecedorCPFCNPJ != null) {
                return (
                    this.fornecedorCPFCNPJ.length == '14' ||
                    this.fornecedorCPFCNPJ.length == '18'
                )
            }

            if(this.fornecedorCodCfo != null) {
                return this.fornecedorCodCfo.length == '8'
            }
            return false
        },

        dataVencimentoRequerJustificativa() {
            if (this.dataVencimento == null || !this.boleto) {
                return false
            }

            let dtAtual = this.$moment(new Date())
            let dtVencimento = this.$moment(this.dataVencimento, 'DD/MM/YYYY')
            if (dtAtual > dtVencimento.subtract(15, 'days')) {
                return true
            }

            return false
        },

        despesaCompra() {
            if (this.despesa == null) {
                return false
            }
            return this.despesa.movimentoCompra
        },

        desabilitaTipoMovimento() {
            if (this.acao != 'INSERIR') {
                return this.despesaCompra || this.despesa.possuiMovimentoRm
            }
            return false
        }
    },

    validations: {
        fornecedorCPFCNPJ: {
            obrigatorio() {
                if (!this.perfilFornecedor && !this.fornecedorExterno) {
                    return this.validaTamanhoCpfCnpj
                }

                return true
            }
        },

        fornecedorCodCfo: {
            obrigatorio() {
                if (!this.perfilFornecedor && this.fornecedorExterno) {
                    if (this.acao == 'ATUALIZAR') {
                        return true
                    }
                    return this.fornecedorCodCfo != null
                }
                return true
            }
        },

        fornecedorDto: {
            obrigatorio() {
                if (!this.perfilFornecedor) {
                    return this.fornecedorDto != null
                }
                return true
            }
        },

        demandante: {
            required,
            existe(){
                return this.opcoes.funcionarios.find(x => x.chapa == this.demandante) != null
            }
        },

        tipoMovimento: {
            required
        },

        autorizante: {
            autorizanteValido() {
                if (this.alcadaGerencia) {
                    return this.autorizante != null
                }
                return true
            }
        },

        dataEmissao: {
            required
        },

        dataMovimento: {
            required
        },

        dataVencimento: {
            eBoleto() {
                if (this.boleto) {
                    return this.dataVencimento != null
                }
                return true
            }
        },

        justificativaDataVencimento: {
            eBoleto() {
                if (this.dataVencimentoRequerJustificativa) {
                    return (
                        this.justificativaDataVencimento != '' &&
                        this.justificativaDataVencimento != null
                    )
                }
                return true
            }
        },

        historico: {
            required
        }
    },

    components: {
        ModelListSelect
    }
}
</script>
